import { createSelector } from '@reduxjs/toolkit';

import { MORTGAGE_PROMO_TYPES } from '../../constants/newbuildingPromos';
import { IPromoInfo } from '../../types/newbuildingPromos';
import { getPromoInfos } from '../newObject/getPromoInfos';

export const selectMortgagePromos = createSelector(getPromoInfos, (promos: IPromoInfo[]) =>
  promos.filter(promo => MORTGAGE_PROMO_TYPES.includes(promo.promoType)),
);
